import { c as _c } from "react/compiler-runtime";
import { ReserveHostPoliciesPropertiesTypes } from "@website/widget/reserve-host-policies/reserve-host-policies.types";
export const ReserveHostPolicies = properties => {
  const $ = _c(5);
  const {
    rules
  } = properties;
  let t0;
  if ($[0] !== rules) {
    t0 = rules?.trim() || "";
    $[0] = rules;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const trimmedRules = t0;
  if (!trimmedRules || trimmedRules?.length < 2) {
    return null;
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <h2 className="text-subtitle-1 md:text-headline-6">قوانین میزبان</h2>;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== trimmedRules) {
    t2 = <div className="flex w-full flex-col gap-4" id="hotel_policies">{t1}<div className="text-body-2 text-on-surface-high-emphasis whitespace-pre-wrap break-words">{trimmedRules}</div></div>;
    $[3] = trimmedRules;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};